import type { IconSvgObject } from './types';

const AmpersandIcon: IconSvgObject = [
  ["path", { d: "M18.5 14.1816L15.6128 17.0494M15.6128 17.0494L12.906 19.7379C11.2118 21.4207 8.4649 21.4207 6.77067 19.7379C5.07644 18.0551 5.07644 15.3267 6.77067 13.6439L9.47744 10.9553M15.6128 17.0494L9.47744 10.9553M15.6128 17.0494L18.5 19.9171M9.47744 10.9553L11.8233 8.62527C13.1189 7.33841 13.1189 5.252 11.8233 3.96514C10.5277 2.67829 8.42716 2.67829 7.13157 3.96514C5.83599 5.252 5.83599 7.33841 7.13157 8.62527L9.47744 10.9553Z", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }]
];

export default AmpersandIcon;
